/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_AI_ASSISTANT_HELP = {
  screenId: 'settings-ai-assistant',
  label: 'Asistente IA',
  navPath: 'Configuración (ruedita) → Asistente IA',
  keywords: ['inteligencia artificial', 'chat', 'ayuda', 'asistente', 'soporte'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Activar u ocultar el asistente de soporte que responde preguntas sobre el uso de Pymego.',
  sidebarItems: [{
    id: 'ai-assistant',
    screenId: 'settings-ai-assistant',
    label: 'Preferencia del asistente',
    description: 'Mostrar u ocultar el chat de ayuda con IA.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'El asistente responde en lenguaje simple preguntas sobre cómo usar el sistema. Acá elegís si querés verlo o no en tu usuario.',
        },
        {
          title: 'Paso 1 — Abrir la ventana',
          steps: [
            'Tocá el ícono de configuración (ruedita) arriba a la derecha.',
            'Elegí «Asistente IA».',
          ],
        },
        {
          title: 'Paso 2 — Activar u ocultar',
          bullets: [
            'Marcá «Mostrar asistente de IA» para ver el chat flotante en las pantallas.',
            'Desmarcá la casilla para ocultarlo.',
            'Tocá «Guardar» para aplicar el cambio.',
          ],
          paragraphs: [
            'También podés cambiar esta preferencia en Configuración → Valores predeterminados.',
          ],
        },
        {
          title: 'Si lo desactivaste',
          paragraphs: [
            'Para volver a activarlo: Configuración → Asistente IA, o Valores predeterminados → Mostrar asistente de IA.',
          ],
        },
      ],
    },
  }],
}
